module.exports = __webpack_public_path__ + "assets/onstar-system.1082b2ff.svg";